"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _FormActions = require("./FormActions");

var initialState = {
  document: {},
  loading: false,
  error: null
};

var FormReducer = function FormReducer(state, action) {
  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case _FormActions.LOAD_FORM:
      return (0, _extends2["default"])({}, state, {
        loading: action.payload
      });

    case _FormActions.LOAD_FORM_SUCCESS:
      return (0, _extends2["default"])({}, state, {
        document: action.payload,
        loading: false
      });

    case _FormActions.LOAD_FORM_ERROR:
      return (0, _extends2["default"])({}, state, {
        loading: false,
        error: action.payload
      });

    default:
      return state;
  }
};

var _default = exports["default"] = FormReducer;